<template>
<li class="kt-nav__separator"></li>
</template>

<script>
export default {
    
}
</script>